import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=2cd6ee31&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=tsx&"
export * from "./Tabs.vue?vue&type=script&lang=tsx&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=2cd6ee31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6ee31",
  null
  
)

export default component.exports